import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Spinner } from "reactstrap";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import PlusIcon from "../../../components/Icons/PlusIcon";
import {
  formatAmount,
  parseAmount,
} from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import moment from "moment";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import MultipleGTC from "./MultipleGTC";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import MultiSelectDropdown from "../../../components/comman/MultiSelectDropdown";

export default function CreatePurchase() {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location?.state?.data==========>", location?.state?.data);
  const [dataLoading, setDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [files, setFiles] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [confirmModal, setConfirmModal] = useState(false);
  const toggleConfirmModal = () => setConfirmModal(!confirmModal);
  const [selectedId, setSelectedId] = useState("");
  const [state, setState] = useState({
    vendorList: [],
    vendorName: "",
    isLoadingVendor: false,
    gtc: [],
    itemsByExpenseHead: {},
  });
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      expenseHead: [
        {
          heading: "",
          total: "",
          items: [
            {
              item: "",
              quantity: "",
              updatedQuantity: "",
              unit: "",
              rate: "",
              gst: "",
              amount: "",
              amountWithGst: "",
            },
          ],
        },
      ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "expenseHead",
  });

  const watchItems = watch("expenseHead") || [];

  const fetchItemsForExpenseHeads = (expenseHeads) => {
    if (!expenseHeads || expenseHeads.length === 0) return;
    expenseHeads.forEach((eh) => {
      const expenseHeadId = eh?.expensehead?.id;
      if (expenseHeadId) {
        callApi(apiUrl.get_items + `expenseHeadId=${expenseHeadId}&all=true`, { method: "GET" })
          .then((res) => {
            if (res?.status === true) {
              const fetchedItems = res?.data?.item || res?.data || [];
              setState((prev) => ({
                ...prev,
                itemsByExpenseHead: {
                  ...(prev.itemsByExpenseHead || {}),
                  [expenseHeadId]: fetchedItems,
                },
              }));
            }
          });
      }
    });
  };

  const handleAddItem = (expenseIndex, expenseHeadId) => {
    if (!state.itemsByExpenseHead?.[expenseHeadId]) {
      callApi(apiUrl.get_items + `expenseHeadId=${expenseHeadId}&all=true`, { method: "GET" })
        .then((res) => {
          if (res?.status === true) {
            const fetchedItems = res?.data?.item || res?.data || [];
            setState((prev) => ({
              ...prev,
              itemsByExpenseHead: {
                ...(prev.itemsByExpenseHead || {}),
                [expenseHeadId]: fetchedItems,
              },
            }));
          }
        });
    }

    const currentExpenseHeads = watch("expenseHead") || [];
    const targetExpenseHead = currentExpenseHeads[expenseIndex];
    if (targetExpenseHead) {
      const currentItems = targetExpenseHead.items || [];
      const newItem = {
        isNew: true,
        id: null,
        item: "",
        itemId: "",
        hsnCode: "--",
        quantity: "0",
        updatedQuantity: "1",
        unit: "nos",
        rate: "0",
        gst: "0",
        amount: "0",
        amountWithGst: "0",
      };

      setValue(`expenseHead.${expenseIndex}.items`, [...currentItems, newItem]);
    }
  };

  const handleRemoveItem = (expenseIndex, itemIndex) => {
    const currentExpenseHeads = watch("expenseHead") || [];
    const targetExpenseHead = currentExpenseHeads[expenseIndex];
    if (targetExpenseHead) {
      const currentItems = targetExpenseHead.items || [];
      const updatedItems = currentItems.filter((_, idx) => idx !== itemIndex);
      setValue(`expenseHead.${expenseIndex}.items`, updatedItems);

      let expenseHeadTotal = 0;
      updatedItems.forEach((itm) => {
        expenseHeadTotal += parseFloat(parseAmount(itm.amountWithGst)) || 0;
      });

      setValue(
        `expenseHead.${expenseIndex}.total`,
        formatAmount(expenseHeadTotal.toFixed(2))
      );
    }
  };

  const handleItemSelect = (e, expenseIndex, itemIndex, expenseHeadId) => {
    const selectedItemId = e.target.value;
    const itemsList = state.itemsByExpenseHead?.[expenseHeadId] || [];
    const selectedItem = itemsList.find((itm) => itm.id === selectedItemId);

    if (selectedItem) {
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.itemId`, selectedItemId);
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.item`, selectedItem.name);
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.hsnCode`, selectedItem.hsnCode || "--");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.unit`, selectedItem.unit || "nos");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.gst`, selectedItem.gst || "0");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.rate`, selectedItem.standardRate || "0");

      handleQuantityOrRateChange(expenseIndex, itemIndex, "rate", selectedItem.standardRate || "0");
    } else {
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.itemId`, "");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.item`, "");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.hsnCode`, "--");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.unit`, "nos");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.gst`, "0");
      setValue(`expenseHead.${expenseIndex}.items.${itemIndex}.rate`, "0");

      handleQuantityOrRateChange(expenseIndex, itemIndex, "rate", "0");
    }
  };

  useEffect(() => {
    // console.log("PR--------->>", location?.state?.data)
    if (location?.state?.type === "Create") {
      GetVendorList({
        type:
          location?.state?.data?.type === "serviceRequest"
            ? "Service"
            : "Supply",
        siteId: location?.state?.data?.siteId,
      });
    } else {
      GetVendorList({
        type:
          location?.state?.data?.purchaserequest?.type === "serviceRequest"
            ? "Service"
            : "Supply",
        siteId: location?.state?.data?.purchaserequest?.siteId,
      });
    }
  }, []);

  useEffect(() => {
    if (location?.state?.data) {
      if (location?.state?.type === "Edit") {
        let options = {
          method: "GET",
        };
        let API =
          apiUrl?.get_purchase_detail +
          `purchaseId=${location?.state?.data?.id}`;
        setDataLoading(true);
        callApi(API, options).then((response) => {
          setDataLoading(false);
          if (response?.status === true) {
            setState((prev) => ({
              ...prev,
              gtc: response?.data?.gtc ? JSON.parse(response?.data?.gtc) : [],
              vendorName: response?.data?.vendor?.firmName,
            }));
            if (response?.data?.documents?.length > 0) {
              setExistingDocuments(response?.data?.documents);
            }
            reset({
              siteId: response?.data?.purchaserequest?.site?.name,
              date: moment(response?.data?.purchaseDate).format("YYYY-MM-DD"),
              vendorId: response?.data?.vendor?.id,
              paymentTerms: response?.data?.paymentTerms,
              gstType: response?.data?.gstType,
              content: response?.data?.description || "",
              expenseHead:
                response?.data?.purchaserequest?.purchaserequestexpenseheads?.map(
                  (field, index) => {
                    return {
                      ...field,
                      heading: field?.expensehead?.name,
                      items: field?.supplyrequestitems?.map((item, i) => {
                        const quantity = parseFloat(item?.updatedQuantity) || 0;
                        const rate = parseFloat(item?.rate) || 0;
                        const gst = parseFloat(item?.gst) || 0;
                        const month = response?.data?.purchaserequest?.type === "serviceRequest"
                          ? (parseFloat(item?.month) || 1) : 1;

                        // Base total without GST (including month for service requests)
                        const total = month * quantity * rate;
                        // GST Calculation
                        const gstAmount = (total * gst) / 100;
                        // Final Amount including GST
                        const amountWithGst = total + gstAmount;

                        // // Accumulate totalAmount for expense head
                        // totalAmount += amountWithGst;

                        // printData(item)

                        return {
                          ...item,
                          item: item?.item?.name,
                          quantity: item?.quantity,
                          updatedQuantity: item?.updatedQuantity,
                          unit: item?.item?.unit,
                          rate: item?.rate,
                          gst: item?.gst,
                          month: item?.month,
                          hsnCode: item?.item?.hsnCode,
                          amount: formatAmount(total), // Base amount
                          amountWithGst: formatAmount(amountWithGst), // Total with GST
                        };
                      }),
                      total: formatAmount(field?.total), // Total including GST
                    };
                  }
                ),
            });
            const ehList = response?.data?.purchaserequest?.purchaserequestexpenseheads || [];
            fetchItemsForExpenseHeads(ehList);
          }
        });
      } else {
        const ehList = location?.state?.data?.purchaserequestexpenseheads || [];
        reset({
          siteId: location?.state?.data?.site?.name,
          expenseHead: ehList.map(
            (field, index) => {
              return {
                ...field,
                heading: field?.expensehead?.name,
                total: "0",
                items: field?.supplyrequestitems?.map((item, i) => {
                  return {
                    ...item,
                    item: item?.item?.name,
                    hsnCode: item?.item?.hsnCode || "--",
                    quantity: item?.quantity,
                    updatedQuantity: item?.quantity,
                    unit: item?.item?.unit,
                    rate: "0",
                    gst: "0",
                    amount: "0",
                    amountWithGst: "0",
                  };
                }),
              };
            }
          ),
        });
        fetchItemsForExpenseHeads(ehList);
      }
    }
  }, [state?.vendorList]);


  const GetVendorList = (type, inputValue) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_vendor +
      `${inputValue ? `?search=${inputValue}&` : "?"}` +
      MainFilterHandler(type);
    callApi(Url, options).then((res) => {
      if (res?.status === true) {
        const newData = res?.data?.vendor?.map((item) => ({
          ...item,
          label: item?.firmName,
          value: item?.id,
        }));
        setState((pre) => ({
          ...pre,
          vendorList: newData,
        }));
      }
    });
    if (location?.state?.type === "Edit") {
      setTimeout(() => {
        // console.log("Hiii");
        setValue("vendorId", location?.state?.data?.vendorId);
      }, 500);
    }
  };

  const handleQuantityOrRateChange = (
    expenseIndex,
    itemIndex,
    fieldType,
    value
  ) => {
    // printData("UpdateData", value);

    // Convert input to floating-point number safely
    const updatedValue = value;

    // Update the field
    setValue(
      `expenseHead.${expenseIndex}.items.${itemIndex}.${fieldType}`,
      updatedValue
    );

    // Get the current state of items
    const currentItems = watch("expenseHead") || [];
    const item = currentItems[expenseIndex]?.items[itemIndex] || {};

    // Extract and ensure valid floating-point numbers
    const quantity =
      fieldType === "updatedQuantity"
        ? parseFloat(updatedValue) || 0
        : parseFloat(item.updatedQuantity) || 0;
    const rate =
      fieldType === "rate"
        ? parseFloat(updatedValue) || 0
        : parseFloat(item.rate) || 0;
    const gstSlab = parseFloat(item.gst) || 0; // Ensure GST slab is a number

    // Get month value for service request calculation
    const isServiceRequest = location?.state?.data?.type === "serviceRequest" ||
      location?.state?.data?.purchaserequest?.type === "serviceRequest";
    const month = isServiceRequest ? (parseFloat(item.month) || 1) : 1;

    // Calculate base amount and GST (ensuring floating-point precision)
    // For service requests: month × quantity × rate
    const baseAmount = (month * quantity * rate).toFixed(2); // Two decimal places
    const gstAmount = ((baseAmount * gstSlab) / 100).toFixed(2);
    const totalAmount = (
      parseFloat(baseAmount) + parseFloat(gstAmount)
    ).toFixed(2);

    // Update the item amount
    setValue(
      `expenseHead.${expenseIndex}.items.${itemIndex}.amountWithGst`,
      formatAmount(totalAmount || 0)
    );
    setValue(
      `expenseHead.${expenseIndex}.items.${itemIndex}.amount`,
      baseAmount
    );

    // Calculate total for items within each Expense Head
    let expenseHeadTotal = 0;
    currentItems[expenseIndex].items.forEach((itm) => {
      expenseHeadTotal += parseFloat(parseAmount(itm.amountWithGst)) || 0;
    });

    setValue(
      `expenseHead.${expenseIndex}.total`,
      formatAmount(expenseHeadTotal.toFixed(2))
    );
  };

  const GetGrandTotal = () => {
    let newGrandTotal = 0;
    watchItems.forEach((expense) => {
      newGrandTotal += parseAmount(expense.total || "0");
    });
    return newGrandTotal;
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile },
      ]);
    }
    event.target.value = "";
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = () => {
    const API = `${apiUrl.delete_document}?documentId=${selectedId}`;
    callApi(API, { method: "GET" }).then((response) => {
      toggleConfirmModal();
      if (response?.status === true) {
        setExistingDocuments((prev) =>
          prev.filter((doc) => doc.id !== selectedId)
        );
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const ActionHandler = (id) => {
    setSelectedId(id);
    toggleConfirmModal();
  };

  const DocumentsRequiredForPO = [
    {
      id: 1,
      name: "Invoice"
    },
    {
      id: 2,
      name: "Performa Invoice"
    },
    {
      id: 3,
      name: "Attendance sheet verified by S.Nath Incharge"
    },
    {
      id: 4,
      name: "Abstractsheet verified by S.Nath Incharge"
    },
    {
      id: 5,
      name: "Attendance / Abstract sheet"
    },
    {
      id: 6,
      name: "Compliance"
    },
    {
      id: 7,
      name: "Log book verified by S.Nath Incharge"
    },
    {
      id: 8,
      name: "Supporting Documents"
    },
    {
      id: 9,
      name: "Receipt"
    },
    {
      id: 10,
      name: "Other Document"
    },
  ];

  const handleDocumentChange = (selectedValues) => {
    const newNames = selectedValues?.map((item) => item?.name) || [];

    if (newNames.includes("Invoice") && newNames.includes("Performa Invoice")) {
      toast.warning("You can only select either Invoice or Performa Invoice.");
      return;
    }

    setState((prevStates) => ({
      ...prevStates,
      gtc: newNames,
    }));
  };

  const onSubmit = (data) => {
    const totalItemsCount = watchItems.reduce((acc, curr) => acc + (curr?.items?.length || 0), 0);
    const grandTotal = GetGrandTotal();

    if (totalItemsCount === 0 || grandTotal === 0) {
      toast.error("Items do not exist or grand total is 0. Cannot submit.");
      return;
    }

    const emptyRates = watchItems.flatMap((expenseHead) =>
      expenseHead.items.filter((item) => item.rate == 0 || "")
    );
    // console.log(emptyRates);

    if (emptyRates.length > 0) {
      toast.info("Please fill all the Fields before submit");
      return;
    }
    if (state?.gtc.length == 0) {
      toast.error("Please add documents checklist for billing");
      return;
    }

    const submitData = {
      purchaseDate: data?.date,
      description: data?.content,
      totalAmount: GetGrandTotal(),
      purchaseRequestId:
        location?.state?.type === "Create"
          ? location?.state?.data?.id
          : location?.state?.data?.purchaseRequestId,
      vendorId: data?.vendorId,
      paymentTerms: data?.paymentTerms,
      gstType: data?.gstType,
      gtc: JSON.stringify(state?.gtc),
      data: watchItems?.map((expenseHead) => ({
        total: parseAmount(expenseHead?.total),
        purchaseRequestExpenseHeadId: expenseHead?.id,
        supplyRequestItem: expenseHead?.items?.map((item) => ({
          quantity: item?.updatedQuantity,
          ...(location?.state?.data?.type === "serviceRequest" || location?.state?.data?.purchaserequest?.type === "serviceRequest" ? { month: item?.month } : {}),
          rate: item?.rate,
          gst: item?.gst,
          id: item?.id || null,
          itemId: item?.itemId || item?.item?.id || null,
        })),
      })),
    };

    // console.log("submitData=============>", submitData);

    const formData = new FormData();

    for (const key in submitData) {
      if (submitData[key] !== undefined && submitData[key] !== null) {
        if (key === "data") {
          formData.append(key, JSON.stringify(submitData[key]));
        } else {
          formData.append(key, submitData[key]);
        }
      }
    }

    files.forEach((f) => formData.append(f.file.name, f.file));

    const optionPurchase = {
      method: "POST",
      form_data: formData,
    };
    const endPoint =
      location?.state?.type === "Edit"
        ? apiUrl.update_purchase + `?purchaseId=${location?.state?.data?.id}`
        : apiUrl.create_purchase;
    setIsLoading(true);
    callApi(endPoint, optionPurchase).then((res) => {
      if (res.status === true) {
        toast.success(res?.message);
        setIsLoading(false);
        navigate(-1);
      } else {
        toast.error(res?.message);
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">{location?.state?.type} Purchase</h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                {location?.state?.data?.purchaseNumber && (
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">PO No.</label>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        value={location?.state?.data?.purchaseNumber}
                        disabled
                      />
                    </div>
                  </div>
                )}

                {location?.state?.data?.purchaceRequestNumber && (
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label className="form-label">PR No.</label>
                      <input
                        className="form-control"
                        aria-label="Default select example"
                        value={location?.state?.data?.purchaceRequestNumber}
                        disabled
                      />
                    </div>
                  </div>
                )}

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                        validate: (value) => {
                          const checkDate = moment(value).startOf('day');
                          const today = moment().startOf('day');
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="vendorId"
                      control={control}
                      rules={{ ...errorTypes.required("Vendor") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Vendor"
                          placeholder="Search Vendor"
                          value={state.vendorName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteName: option?.label,
                            }));
                            setValue("vendorId", option?.value);
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={state.vendorList}
                          onSearch={(search) => {
                            if (location?.state?.type === "Create") {
                              GetVendorList(
                                {
                                  type:
                                    location?.state?.data?.type ===
                                      "serviceRequest"
                                      ? "Service"
                                      : "Supply",
                                  siteId: location?.state?.data?.siteId,
                                },
                                search
                              );
                            } else {
                              GetVendorList(
                                {
                                  type:
                                    location?.state?.data?.purchaserequest
                                      ?.type === "serviceRequest"
                                      ? "Service"
                                      : "Supply",
                                  siteId:
                                    location?.state?.data?.purchaserequest
                                      ?.siteId,
                                },
                                search
                              );
                            }
                          }}
                          isLoading={state?.isLoadingVendor}
                          showAddButton={false}
                          required={true}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Site<span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      aria-label="Default select example"
                      {...register("siteId", {
                        required: "Please select site",
                      })}
                      disabled
                    />
                    <ErrorMessage message={errors?.siteId?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Payment Term<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("paymentTerms", {
                        required: "Please select payment term",
                      })}
                    >
                      <option value="" className="d-none">
                        Select Payment Term
                      </option>
                      <option value={"Same-Day Settlement"}>
                        Same-Day Settlement
                      </option>
                      <option value={"With-in 07 days"}>With-in 07 days</option>
                      <option value={"With-in 15 days"}>With-in 15 days</option>
                      <option value={"With-in 30 days"}>With-in 30 days</option>
                      <option value={"With-in 45 days"}>With-in 45 days</option>
                    </select>
                    <ErrorMessage message={errors?.paymentTerms?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      GST Type<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("gstType", {
                        required: "Please select GST Type",
                      })}
                    >
                      <option value="" className="d-none">
                        Select GST Type
                      </option>
                      <option value={"IGST"}>IGST</option>
                      <option value={"CGST + SGST"}>CGST + SGST</option>
                    </select>
                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">Financial Year</label>
                    <input type="text" className="form-control" disabled
                      value={location?.state?.data?.financialYear || "--"} />
                  </div>
                </div>

                <div className="col-4">
                  <div className="form-group mb-0">
                    <label htmlFor="Role" className="form-label fw-semibold text-dark mb-2" style={{ fontSize: "14px" }}>
                      Documents Checklist for Billing
                    </label>
                    <MultiSelectDropdown
                      options={DocumentsRequiredForPO || []}
                      isLoading={false}
                      placeholder='Search & Select Documents...'
                      selectedValues={DocumentsRequiredForPO?.filter((doc) => state?.gtc?.includes(doc?.name)) || []}
                      onChange={(values) => handleDocumentChange(values)}
                      multiSelect={true}
                      setPageStates={setState}
                      search={true}
                      showSelectAll={false}
                      showUnSelectAll={false}
                      emptyMessage="No Documents Found"
                    />
                  </div>
                </div>

                <div className="col-12">
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                    <h4 className="fs-3 rajdhani-semibold my-4 ">
                      Item Details
                    </h4>
                  </div>
                  {watchItems.map((field, index) => (
                    <div key={field.id || index}>
                      <div className="d-flex align-items-center justify-content-between border-bottom mb-4">
                        <h4 className="fs-3 rajdhani-semibold my-4 ">
                          {field.heading}
                        </h4>
                        <button
                          type="button"
                          className="btn btn-outline-primary btn-sm my-4"
                          onClick={() => handleAddItem(index, field.expensehead?.id)}
                        >
                          <PlusIcon /> Add Item
                        </button>
                      </div>
                      <table className="table mt-3">
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>HSN Code</th>
                            <th>Quantity</th>
                            <th>Approved Qty</th>
                            {(location?.state?.data?.type === "serviceRequest" || location?.state?.data?.purchaserequest?.type === "serviceRequest") && (
                              <th>Month</th>
                            )}
                            <th>Rate</th>
                            <th
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              GST
                            </th>
                            <th>Amount</th>
                            <th>Amount With GST</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {field.items.map((item, i) => (
                            <tr key={i}>
                              <td style={{ minWidth: "350px" }}>
                                {item.isNew ? (
                                  <Controller
                                    name={`expenseHead.${index}.items.${i}.itemId`}
                                    control={control}
                                    rules={{ required: "Please select an item" }}
                                    render={({ field: controllerField, fieldState }) => {
                                      const itemsList = state.itemsByExpenseHead?.[field.expensehead?.id] || [];
                                      const optionsList = itemsList.map((itm) => {
                                        const isAlreadySelected = field.items?.some((rowItem, rowIndex) => {
                                          if (rowIndex === i) return false;
                                          const rowItemId = rowItem?.itemId || rowItem?.item?.id;
                                          if (rowItemId && rowItemId === itm.id) return true;
                                          if (rowItem?.item === itm.name) return true;
                                          return false;
                                        });
                                        return {
                                          label: `${itm.name} (HSN: ${itm.hsnCode || "--"})`,
                                          value: itm.id,
                                          disabled: isAlreadySelected,
                                        };
                                      });

                                      const selectedItem = itemsList.find((itm) => itm.id === controllerField.value);
                                      const selectedLabel = selectedItem ? `${selectedItem.name} (HSN: ${selectedItem.hsnCode || "--"})` : "";

                                      return (
                                        <SearchSelectInput
                                          label=""
                                          placeholder="Search Item"
                                          value={selectedLabel}
                                          options={optionsList}
                                          onSelect={(option) => {
                                            controllerField.onChange(option?.value);
                                            const dummyEvent = { target: { value: option?.value } };
                                            handleItemSelect(dummyEvent, index, i, field.expensehead?.id);
                                          }}
                                          className="mb-0"
                                          errors={fieldState.error?.message}
                                        />
                                      );
                                    }}
                                  />
                                ) : (
                                  <input
                                    className="form-control"
                                    {...register(
                                      `expenseHead.${index}.items.${i}.item`,
                                      {
                                        required: "Please select an item",
                                      }
                                    )}
                                    disabled
                                    placeholder="Item"
                                  />
                                )}
                              </td>
                              <td style={{ minWidth: "100px" }}>
                                <input
                                  className="form-control"
                                  {...register(
                                    `expenseHead.${index}.items.${i}.hsnCode`,
                                    {
                                      required: "Please enter HSN",
                                    }
                                  )}
                                  disabled
                                  placeholder="HSN Code"
                                />
                              </td>

                              <td style={{ minWidth: "80px" }}>
                                <div className="input-group">
                                  <input
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="form-control"
                                    placeholder="Quantity"
                                    min={0}
                                    {...register(
                                      `expenseHead.${index}.items.${i}.quantity`,
                                      {
                                        required: "Please enter a quantity",
                                      }
                                    )}
                                    disabled
                                    onChange={(e) =>
                                      handleQuantityOrRateChange(
                                        index,
                                        "quantity",
                                        e.target.value
                                      )
                                    }
                                  />
                                  <span className="input-group-text">
                                    {item?.unit}
                                  </span>
                                </div>
                              </td>
                              <td style={{ minWidth: "80px" }}>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Quantity"
                                    {...register(
                                      `expenseHead.${index}.items.${i}.updatedQuantity`,
                                      {
                                        required: "Please enter a quantity",
                                      }
                                    )}
                                    onChange={(e) => {
                                      let value = e.target.value
                                        .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                        .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

                                      // Ensure a valid floating-point format
                                      if (!/^\d*\.?\d*$/.test(value)) {
                                        value = "";
                                      }
                                      handleQuantityOrRateChange(
                                        index,
                                        i,
                                        "updatedQuantity",
                                        value
                                      );
                                    }}
                                  />
                                  <span className="input-group-text">
                                    {item?.unit}
                                  </span>
                                </div>
                              </td>
                              {(location?.state?.data?.type === "serviceRequest" || location?.state?.data?.purchaserequest?.type === "serviceRequest") && (
                                <td style={{ width: "40px" }}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Month"
                                    onWheel={(e) => e.currentTarget.blur()}
                                    {...register(
                                      `expenseHead.${index}.items.${i}.month`
                                    )}
                                    disabled
                                  />
                                </td>
                              )}
                              <td style={{ minWidth: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Rate"
                                  {...register(
                                    `expenseHead.${index}.items.${i}.rate`,
                                    {
                                      required:
                                        "Please enter a valid floating-point number",
                                    }
                                  )}
                                  onChange={(e) => {
                                    let value = e.target.value
                                      .replace(/[^0-9.]/g, "") // Allow only digits and dots
                                      .replace(/(\..*)\./g, "$1"); // Prevent multiple dots

                                    // Ensure a valid floating-point format
                                    if (!/^\d*\.?\d*$/.test(value)) {
                                      value = "";
                                    }

                                    e.target.value = value; // Update input field
                                    handleQuantityOrRateChange(
                                      index,
                                      i,
                                      "rate",
                                      value
                                    );
                                  }}
                                />
                              </td>
                              <td >
                                <select
                                  className="form-select form-control "
                                  placeholder="Select GST"
                                  {...register(
                                    `expenseHead.${index}.items.${i}.gst`,
                                    {
                                      required: "Please select GST",
                                    }
                                  )}
                                  onChange={(e) => {
                                    e.target.value = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );
                                    handleQuantityOrRateChange(
                                      index,
                                      i,
                                      "gst",
                                      e.target.value
                                    );
                                  }}
                                >
                                  <option value="" className="d-none">
                                    GST
                                  </option>
                                  <option value="0">0%</option>
                                  <option value="5">5%</option>
                                  <option value="12">12%</option>
                                  <option value="18">18%</option>
                                  <option value="28">28%</option>
                                </select>
                              </td>
                              <td style={{ minWidth: "100px" }}>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Amount"
                                  readOnly
                                  disabled
                                  {...register(
                                    `expenseHead.${index}.items.${i}.amount`
                                  )}
                                />
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Amount With GST"
                                  readOnly
                                  disabled
                                  {...register(
                                    `expenseHead.${index}.items.${i}.amountWithGst`
                                  )}
                                />
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-link text-danger p-0"
                                  onClick={() => handleRemoveItem(index, i)}
                                >
                                  <DeleteIcon />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td></td>
                            {(location?.state?.data?.type === "serviceRequest" || location?.state?.data?.purchaserequest?.type === "serviceRequest") && (
                              <td></td>
                            )}
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="fw-bold">Total</td>
                            <td>
                              <input
                                type="text"
                                className="form-control"
                                {...register(`expenseHead.${index}.total`)}
                                readOnly
                                disabled
                              />
                            </td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  ))}
                  <div className="d-flex align-items-center justify-content-end border-bottom mb-4">
                    <h4 className="fs-3 rajdhani-semibold my-4 ">
                      Grand Total: {formatAmount(GetGrandTotal())}
                    </h4>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12  " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Uploads
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => ActionHandler(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required", // Field is required
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData()); // Update form state on change
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px", // custom height for CKEditor
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? <Spinner /> : location?.state?.type}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ConfirmModal
        modal={confirmModal}
        toggle={toggleConfirmModal}
        submitHandler={handleDeleteDocument}
        isLoading={isLoading}
      />
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
